import { withTranslation } from 'react-i18next';
import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'reactstrap';
import InfoIcon from '@material-ui/icons/Info';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Field, reduxForm } from 'redux-form';
import validate from './components/Validate';
import SmartCard from '../../shared/components/SmartCard';
import GraphQL from '../../GraphQL';
import { objectsToChangePass } from '../../shared/queries/ChangePassResponsible';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import Select from '../../shared/components/form/Select';
import MultiEmail from '../../shared/components/form/MultiEmail';
import TextAreaField from '../../shared/components/form/TextAreaField';

const ChangePassResponsible = (props) => {
  const {
    t,
    hideLoading,
    handleSubmit,
    showLoading,
    change,
    initialize,
    listOfPassResponsible,
  } = props;

  const [responsibles, setResponsibles] = useState();

  function loadResponsibles() {
    showLoading();
    const query = objectsToChangePass();
    GraphQL(query, {})
      .then((res) => {
        if (res.objectsToChangePass) {
          res.objectsToChangePass = res.objectsToChangePass.map((item) => ({
            ...item,
            value: item.id,
            label: item.name,
          }));
          setResponsibles(res.objectsToChangePass);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }

  const useStyles = makeStyles((theme) => ({
    InfoIcon: {
      marginTop: 28,
      marginLeft: 18,

      [theme.breakpoints.down(801)]: {
        marginLeft: 0,
        marginTop: 0,
        marginBottom: 20,
      },
    },

    LabelObs: {
      color: '#ff1515',
      fontWeight: 'bold',
    },
  }));

  const classes = useStyles();

  const onChangeEmailCc = (values) => {
    change('emailCc', values);
  };

  const formatListOfPass = () => {
    return listOfPassResponsible
      .map(
        (item) =>
          `${t('general.name')}: ${item.fullName} - ${t('general.email')}: ${
            item.email
          } - ${t('general.password')}: ${item.password}\n\n`
      )
      .join('');
  };

  useEffect(() => {
    loadResponsibles();
    initialize({
      emailCc: [],
      listOfPassResponsible: formatListOfPass(),
    });
  }, []);

  useEffect(() => {
    initialize({
      emailCc: [],
      listOfPassResponsible: formatListOfPass(),
    });
  }, [listOfPassResponsible]);

  return (
    <SmartCard title={t('send_responsible_pass.title')}>
      <Fragment>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__form-group--2_columns">
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('send_responsible_pass.copy_emails')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="emailCc"
                  component={MultiEmail}
                  onChange={onChangeEmailCc}
                  placeholder={t('send_responsible_pass.copy_emails')}
                />
              </div>
            </div>
            <Tooltip title={t('send_responsible_pass.info')}>
              <InfoIcon className={classes.InfoIcon} />
            </Tooltip>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.responsible')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="objects"
                type="text"
                component={Select}
                isMulti
                closeMenuOnSelect={false}
                options={responsibles}
                placeholder={t('general.responsible')}
              />
            </div>
          </div>
          <ButtonToolbar>
            <Button color="success" type="submit">
              {t('general.send')}
            </Button>
          </ButtonToolbar>
          <div className="form__form-group">
            <span className={classes.LabelObs}>
              {t('send_responsible_pass.observation')}
            </span>
          </div>
          {listOfPassResponsible.length ? (
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.new-password')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="listOfPassResponsible"
                  type="text"
                  component={TextAreaField}
                  readOnly
                />
              </div>
            </div>
          ) : null}
        </form>
      </Fragment>
    </SmartCard>
  );
};

ChangePassResponsible.propTypes = {
  t: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
  listOfPassResponsible: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
};

ChangePassResponsible.defaultProps = {
  listOfPassResponsible: [],
};

export default reduxForm({
  form: 'ChangePassResponsible',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(ChangePassResponsible));
